import React from 'react';
import LabelPergunta from '../labelPergunta/LabelPergunta';
import styles from './InputGroupPergunta.module.scss';

function InputGroupPergunta({ label = '', children, className = '', classNameChildren = '' }) {
    return (
        <div className={`${styles.container} ${className}`}>
            <LabelPergunta descricao={label} isBlue />
            <div className={`${styles.containerChildren} ${classNameChildren}`}>{children}</div>
        </div>
    );
}

export default InputGroupPergunta;
